import { z } from "zod";
import { ULIDSchema } from "./primitives.js";
import { RecipeApiItemSchema } from "./recipe.js";
// ---------- PhotoKey ----------
export const PhotoKeySchema = ULIDSchema("ph");
// ---------- Constants ----------
export const PHOTO_CONTENT_TYPE = "image/webp";
// `extract` (2560px) is the high-res copy sent to the vision LLM for photo
// import; it lives only in staging/ (24h TTL) and is never stored on the recipe.
export const PHOTO_SIZES = ["thumb", "full", "extract"];
export const MAX_PHOTOS_PER_RECIPE = 10;
// Thumb 400px / full 1920px / extract 2560px — informational; server doesn't
// verify dimensions. `extract` matches Sonnet 5's high-res vision ceiling.
export const PHOTO_DIMENSIONS = {
    thumb: { maxEdge: 400 },
    full: { maxEdge: 1920 },
    extract: { maxEdge: 2560 },
};
// ---------- POST /recipes/{id}/photos/presign ----------
// Body is empty — recipeId comes from path, userId/householdId from auth headers.
export const PresignPhotoRequestSchema = z.object({}).strict();
export const PresignPhotoResponseSchema = z
    .object({
    photoKey: PhotoKeySchema,
    thumbUrl: z.string().url(),
    fullUrl: z.string().url(),
    expiresAt: z.string(), // ISO; informational for the client
})
    .strict();
// ---------- POST /imports/photo-presign (recipe-less import upload) ----------
// Like PresignPhotoResponse but with a third `extractUrl` (2560px copy for the
// vision LLM). No recipe exists yet — these PUT to staging/<userId>/import/.
export const PhotoImportPresignResponseSchema = z
    .object({
    photoKey: PhotoKeySchema,
    thumbUrl: z.string().url(),
    fullUrl: z.string().url(),
    extractUrl: z.string().url(),
    expiresAt: z.string(), // ISO; informational for the client
})
    .strict();
// ---------- POST /recipes/{id}/photos/confirm ----------
export const ConfirmPhotoRequestSchema = z
    .object({
    photoKey: PhotoKeySchema,
    version: z.number().int().min(1),
    asCover: z.boolean().optional(),
    // Forward-compat for Plan 06 cooking-mode step photos. Plan 05 rejects non-null.
    stepId: ULIDSchema("step").nullable().optional(),
})
    .strict();
export const ConfirmPhotoResponseSchema = z
    .object({
    recipe: RecipeApiItemSchema,
})
    .strict();
// ---------- DELETE /recipes/{id}/photos/{photoKey} ----------
export const DeletePhotoRequestSchema = z
    .object({
    version: z.number().int().min(1),
})
    .strict();
export const DeletePhotoResponseSchema = z
    .object({
    recipe: RecipeApiItemSchema,
})
    .strict();
//# sourceMappingURL=photo.js.map